import React from 'react';
import '../../styles/mobile-app/main.css';

const Main = () => {
    return (
        <div id='mobileAppMain'>
            <div className="container mt-5">
                <div className="row">
                    {/* Left Section */}
                    <div className="col-md-8">
                        <p>
                            <strong>Dear all,</strong>
                        </p>
                        <p>
                            CCSU, Meerut has launched its official mobile application for students.
                            This mobile application aims to provide better communication between
                            students and the university including students in its affiliated
                            colleges. Students will now be able to receive important notifications
                            right on their mobile phones and will also be able to raise any query
                            through this mobile application. University is committed to providing a
                            better education experience to its students and will keep adding more
                            applications to its mobile app.
                        </p>
                        <p>
                            <strong>
                                Please click the following buttons to download the mobile application
                            </strong>
                        </p>
                        <div className="row" style={{ rowGap: 20 }}>
                            {/* Android App Download Button */}
                            {/* <div className="col-md-4">
                                <a
                                    href="https://play.google.com/store/apps/details?id=com.ccsu"
                                    className="mobile-app"
                                >
                                    <img
                                        src="../assets/images/google-play.svg"
                                        alt=""
                                        width={20}
                                        height={20}
                                    />{" "}
                                    Download for Android
                                </a>
                            </div> */}
                            <div className="col-md-4">
                                {/* iOS App Download Button */}
                                <a
                                    href="https://apps.apple.com/in/app/ccsu-meerut-official/id6446219464"
                                    className="mobile-app"
                                >
                                    <img
                                        src="../assets/images/apple.svg"
                                        alt=""
                                        width={20}
                                        height={20}
                                    />{" "}
                                    Download for iOS
                                </a>
                            </div>
                        </div>
                        <ol className="mt-3">
                            <li>
                                How to sign in and sign up after registering yourself on the mobile
                                application
                            </li>
                            <li>
                                How to read, comment, like and share the "Notification" received from
                                the university
                            </li>
                            <li>
                                How to raise a query/grievance with the university for any matter and
                                how to receive and read university's reply.
                            </li>
                        </ol>
                        <div className="embed-responsive embed-responsive-16by9">
                            <iframe
                                className="embed-responsive-item"
                                src="https://www.youtube.com/embed/pUee6sDIp4c"
                                allowFullScreen=""
                                title='mobile-app'
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="mobile-pic">
                            <img
                                src="assets/images/mobile-app/app.jpg"
                                className="img-fluid"
                                alt="App Interface"
                            />
                        </div>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-md-6">{/* Embedded YouTube Video */}</div>
                    <div className="col-md-6">{/* Instructions */}</div>
                </div>
            </div>

        </div>
    )
}

export default Main;